import { withTheme } from 'react-jss';

export const withCMUITheme = withTheme;
